import React, { useEffect, useState } from "react";
import "./CursorT1.css";

const CursorT1 = () => {
  const TAIL_LENGTH = 30;
  const [cursorHistory, setCursorHistory] = useState(
    Array(TAIL_LENGTH).fill({ x: 0, y: 0 })
  );
  const [cursorCircles, setCursorCircles] = useState([]);

  useEffect(() => {
    const onMouseMove = (event) => {
      setCursorHistory((prevHistory) => {
        const newHistory = [...prevHistory];
        newHistory.shift();
        newHistory.push({ x: event.clientX, y: event.clientY });
        return newHistory;
      });
    };

    document.addEventListener("mousemove", onMouseMove);

    return () => {
      document.removeEventListener("mousemove", onMouseMove);
    };
  }, []);

  useEffect(() => {
    const initCursor = () => {
      const circles = Array.from({ length: TAIL_LENGTH }, (_, i) => (
        <div key={i} className="cursor-circle" />
      ));
      setCursorCircles(circles);
    };

    initCursor();
  }, []);

  useEffect(() => {
    let animationFrameId;

    const updateCursor = () => {
      setCursorHistory((prevHistory) => {
        const newHistory = [...prevHistory];

        for (let i = 0; i < TAIL_LENGTH - 1; i++) {
          const current = newHistory[i];
          const next = newHistory[i + 1];

          if (next) {
            const xDiff = next.x - current.x;
            const yDiff = next.y - current.y;

            current.x += xDiff * 0.35;
            current.y += yDiff * 0.35;
          }
        }

        return newHistory;
      });

      animationFrameId = requestAnimationFrame(updateCursor);
    };

    animationFrameId = requestAnimationFrame(updateCursor);

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="goo"
        version="1.1"
        width="100%"
      >
        <defs>
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="6" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 35 -15"
              result="goo"
            />
            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
          </filter>
        </defs>
      </svg>

      <div id="cursor">
        {cursorCircles.map((circle, i) =>
          React.cloneElement(circle, {
            style: {
              transform: `translate(${cursorHistory[i]?.x || 0}px, ${
                cursorHistory[i]?.y || 0
              }px) scale(${i / TAIL_LENGTH})`,
            },
          })
        )}
      </div>
    </>
  );
};

export default CursorT1;
